import styled, { css } from 'styled-components';
import { CustomLink } from '@/components/CustomLink/CustomLink';

const activeTabStyles = css`
  pointer-events: none;
  color: ${({ theme }) => theme.palette.primary.labels};
  border-bottom: 2px solid ${({ theme }) => theme.palette.primary.labels};
`;

const tabsPadding = css`
  margin: 10px 0 20px;
`;

export const Tabs = styled.div<{ $hasPadding: boolean }>`
  display: flex;
  gap: 30px;
  align-items: center;
  ${({ $hasPadding }) => $hasPadding && tabsPadding}
`;

export const Tab = styled(CustomLink)<{
  $isActive: boolean;
}>`
  display: flex;
  align-items: center;
  height: 44px;
  border: none;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  cursor: pointer;
  box-shadow: none;
  user-select: none;
  background-color: transparent;
  border-bottom: 2px solid transparent;
  transition: color 0.1s ease-in-out, border-color 0.1s ease-in-out;
  color: ${({ theme }) => theme.palette.secondary.labels};

  ${({ $isActive }) => $isActive && activeTabStyles}

  &:hover {
    color: ${({ theme }) => theme.palette.primary.labels};
    border-bottom: 2px solid ${({ theme }) => theme.palette.primary.labels};
  }
`;
